const Tax = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "rate": "Rate",
    "tax_type": "Tax Type",
    "search": "Search",

    // PAGE HEADER
    "tax": "Tax",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_tax_rate": "Enter Tax Rate",
    "error_positive": "Number Should be Positive",
    "error_tax_type": "Select Tax Type",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_rate": "RATE",
    "table_tax_type": "TAX TYPE",
}

export default Tax;